import React, { useEffect, useState } from "react";
import "components/Layout/style.css";
import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";
import TextField from "@mui/material/TextField";
import MoneyBank from "assets/img/moneybank.svg";
import { Space } from "antd";
import WelcomeLayout from "pages/Shared/WelcomeLayout";
import { useStore } from "_Store";
import CFATextfield from "components/Ui/CFATextfield";
import Dropdown from "components/Ui/Dropdown";
import RadioButton from "components/Ui/RadioButton";
import { useFormik } from "formik";
import { cahierValidationSchema } from "helpers/Schema/index";
import TextareaAutosize from '@mui/material/TextareaAutosize';
import FilledInput from '@mui/material/FilledInput';
import CahierFarmParcel from "../CahierFarmParcel/index.jsx";
const Treasury = (props) => {
  const { state } = useStore();
  const [saveAndContinue, setSaveAndContinue] = useState(false);
  const [entriesOption, setEntriesOption] = useState([]);
  const [exitsOption, setExitsOption] = useState([]);
  const [file, setFile] = useState(null);
  
  const options = [
    {
      label: "Entrées",
      value: "ENTRIES",
    },
    {
      label: "Sorties",
      value: "EXITS",
    },
  ];

  useEffect(() => {
    const filterEntriesOption = state.entriesAndExitsOptionsList.filter(
      (item) => item.cashTransaction === "ENTRIES"
    );
    const filterExitsOption = state.entriesAndExitsOptionsList.filter(
      (item) => item.cashTransaction === "EXITS"
    );
    setEntriesOption(filterEntriesOption);
    setExitsOption(filterExitsOption);
  }, []);

  const formik = useFormik({
    initialValues: {
      cashTransaction:
        state?.["cahierTableDataResponse"]?.["cashTransaction"] || "",
      typeData: state?.["cahierTableDataResponse"]?.["typeData"] || {},
      file: null,
      justification: null,
    },
    validationSchema: cahierValidationSchema,
    onSubmit: (vals) => {
      let valsData=vals
      Object.keys(vals).forEach((key) => {
        if (vals[key] === {}) {
          delete obj[key];
        }
      });
      vals.file=valsData.file ? valsData.file : "";
      vals.justification=valsData.justification ? valsData.justification : "";
      props.onSubmit(vals, saveAndContinue);
    },
  });

  /* if (name === "culture") {
    addToSteps({ label: "Champs / Culture",value: "culture", element: CahierFarmParcel });
  } else {
    removeFromSteps("culture");
  } */

  const handleFileInputChange=(event)=> {
    const selectedFile = event.target.files[0];
    if (selectedFile && (selectedFile.type === 'application/pdf' ||
                         selectedFile.type === 'image/png' ||
                         selectedFile.type === 'image/jpeg')) {
      setFile(selectedFile);
    formik.setFieldValue('file', selectedFile);
    } else {
      setFile(null);
    }
  }

  const handleDropdownChange = (e) => {
     const selectedValue = e.target.value;
    formik.setFieldValue(`typeData`, {});
    formik.setFieldValue(`typeData.type`, selectedValue);
    if(selectedValue===1){
      props.addToSteps({ label: "Champs / Culture",value: "culture", element: CahierFarmParcel });
    }else{
      props.removeFromSteps("culture");
    }
  };
  return (
    <div>
      <Grid className="stepFormfields">
        <WelcomeLayout
          title={"Trésorerie"}
          containImg={MoneyBank}
          content={"Journal de caisse"}
          task={"Pour un type d'opération que vous souhaitez enregistré, vous devez fournir les informations du journal comme demandé dans les champs ci-dessous. Veillez à fournir toutes les informations demandées."}
          handleSubmit={(save) => {
            formik.handleSubmit();
            setSaveAndContinue(save);
          }}
          backToStartBtn={{ 
            label:'précédent',
            onClick: () => {
              props.onBack();
            } 
          }}
          buttonLabel={"Continuer"}
        >
          <div className="questionPage">
            <div className="transection-option">
              <RadioButton
                options={options}
                value={formik.values?.["cashTransaction"]}
                handleChange={(e) => {
                  formik.handleChange(e);
                  if (formik.values?.["cashTransaction"]?.length) {
                    formik.setFieldValue("typeData", {});
                    // formik.resetForm();
                  }
                }}
                formTitle={"Journal de caisse"}
                radioButtonClass={"optionforans"}
                name="cashTransaction"
                error={Boolean(formik.errors["cashTransaction"])}
              />
              <div
                className="cahiersheet-optionsheet"
                style={{ padding: "0px 25px" }}
              >
                {formik.values?.["cashTransaction"] === "ENTRIES" && (
                  <div className="p-5">
                    <div className="enteres-option">
                      D'où viennent les fonds ?

                    </div>
                    <Box sx={{ minWidth: 120 }}>
                      <Dropdown
                        name={"typeData.type"}
                        label={"Origine des fonds / provenance"}
                        handleChange={handleDropdownChange}
                        options={entriesOption}
                        className="transection-option"
                        value={formik.values?.["typeData"]?.["type"]}
                        error={Boolean(formik.errors?.["typeData"]?.["type"])}
                        errorMessage={formik.errors?.["typeData"]?.["type"]}
                      />
                    </Box>
                    {formik.values?.["typeData"]?.["type"] ? (
                      formik.values?.["typeData"]?.["type"] == 2 ? (
                        <>
                          <Box component="form" noValidate autoComplete="off">
                            <TextField
                              name="typeData.otherReceipts"
                              label="Entrez autres encaissement"
                              onChange={formik.handleChange}
                              value={
                                formik.values?.["typeData"]?.["otherReceipts"]
                              }
                              error={Boolean(
                                formik.errors?.["typeData"]?.["otherReceipts"]
                              )}
                              helperText={
                                formik.errors?.["typeData"]?.["otherReceipts"]
                              }
                            />
                          </Box>
                          <Box>
                            <Space direction="vertical">
                              <CFATextfield
                                name="typeData.cost"
                                onChange={formik.handleChange}
                                label="Montant"
                                value={formik.values?.["typeData"]?.["cost"]}
                                error={Boolean(
                                  formik.errors?.["typeData"]?.["cost"]
                                )}
                              />
                              <div className="bg-[#ededed] w-[60px] flex items-center justify-center cfa-text">
                                <h5>CFA</h5>
                              </div>
                            </Space>
                          </Box>
                          <Dropdown
                            name={`typeData.paymentMadeIn`}
                            label={"Paiement reçu en"}
                            handleChange={(e) => {
                              formik.setFieldValue(
                                `typeData.paymentMadeIn`,
                                e.target.value
                              );
                            }}
                            options={state.paymentOption}
                            className="transection-option"
                            value={
                              formik.values?.["typeData"]?.["paymentMadeIn"]
                            }
                            error={Boolean(
                              formik.errors?.["typeData"]?.["paymentMadeIn"]
                            )}
                            errorMessage={
                              formik.errors?.["typeData"]?.["paymentMadeIn"]
                            }
                          />
                        </>
                      ) : (
                        <>
                          <Box>
                            <Space direction="vertical">
                              <CFATextfield
                                name="typeData.cost"
                                onChange={formik.handleChange}
                                label="Montant"
                                value={formik.values?.["typeData"]?.["cost"]}
                                error={Boolean(
                                  formik.errors?.["typeData"]?.["cost"]
                                )}
                              />
                              <div className="bg-[#ededed] w-[60px] flex items-center justify-center cfa-text">
                                <h5>CFA</h5>
                              </div>
                            </Space>
                          </Box>
                          <Dropdown
                            name="typeData.paymentMadeIn"
                            label={"Paiement reçu en"}
                            handleChange={(e) => {
                              formik.setFieldValue(
                                `typeData.paymentMadeIn`,
                                e.target.value
                              );
                            }}
                            options={state.paymentOption}
                            className="transection-option"
                            value={
                              formik.values?.["typeData"]?.["paymentMadeIn"]
                            }
                            error={Boolean(
                              formik.errors?.["typeData"]?.["paymentMadeIn"]
                            )}
                            errorMessage={
                              formik.errors?.["typeData"]?.["paymentMadeIn"]
                            }
                          />
                        </>
                      )
                    ) : (
                      <></>
                    )}
                  </div>
                )}
                {formik.values?.["cashTransaction"] === "EXITS" && (
                  <div  className="p-5 cahiersheet-optionsheet">
                    <div className="enteres-option">
                      A quoi ont servi les fonds ?
                    </div>
                    <Box sx={{ minWidth: 120 }}>
                      <Dropdown
                        name="typeData.type"
                        label={"Destination"}
                        handleChange={(e) => {
                          formik.setFieldValue(`typeData`, {});
                          formik.setFieldValue(
                            `typeData.type`,
                            e.target.value
                          );
                        }}
                        options={exitsOption}
                        className="transection-option"
                        value={formik.values?.["typeData"]?.["type"]}
                        error={Boolean(formik.errors?.["typeData"]?.["type"])}
                        errorMessage={formik.errors?.["typeData"]?.["type"]}
                      />
                    </Box>
                    {formik.values?.["typeData"]?.["type"] ? (
                      formik.values?.["typeData"]?.["type"] == "140" ? (
                        <>
                          <Box component="form" noValidate autoComplete="off">
                            <TextField
                              name="typeData.otherDisbursements"
                              className="outlined-basic"
                              label="Entrez autres decaisenment"
                              onChange={formik.handleChange}
                              value={
                                formik.values?.["typeData"]?.[
                                "otherDisbursements"
                                ]
                              }
                              error={Boolean(
                                formik.errors?.["typeData"]?.[
                                "otherDisbursements"
                                ]
                              )}
                              helperText={
                                formik.errors?.["typeData"]?.[
                                "otherDisbursements"
                                ]
                              }
                            />
                          </Box>
                          <Box>
                            <Space direction="vertical">
                              <CFATextfield
                                name={"typeData.cost"}
                                onChange={formik.handleChange}
                                label="Montant"
                                value={formik.values?.["typeData"]?.["cost"]}
                                error={Boolean(
                                  formik.errors?.["typeData"]?.["cost"]
                                )}
                              />
                              <div className="bg-[#ededed] w-[60px] flex items-center justify-center cfa-text">
                                <h5>CFA</h5>
                              </div>
                            </Space>
                          </Box>
                          <Dropdown
                            name={"typeData.paymentMadeIn"}
                            label={"Paiement effectué en"}
                            handleChange={(e) => {
                              formik.setFieldValue(
                                `typeData.paymentMadeIn`,
                                e.target.value
                              );
                            }}
                            options={state.paymentOption}
                            className="transection-option"
                            value={
                              formik.values?.["typeData"]?.["paymentMadeIn"]
                            }
                            error={Boolean(
                              formik.errors?.["typeData"]?.["paymentMadeIn"]
                            )}
                            errorMessage={
                              formik.errors?.["typeData"]?.["paymentMadeIn"]
                            }
                          />
                        </>
                      ) : (
                        <>
                          <Box>
                            <Space direction="vertical">
                              <CFATextfield
                                onChange={formik.handleChange}
                                label="Montant"
                                name={"typeData.cost"}
                                value={formik.values?.["typeData"]?.["cost"]}
                                error={Boolean(
                                  formik.errors?.["typeData"]?.["cost"]
                                )}
                              />
                              <div className="bg-[#ededed] w-[60px] flex items-center justify-center cfa-text">
                                <h5>CFA</h5>
                              </div>
                            </Space>
                          </Box>
                          <Dropdown
                            name={"typeData.paymentMadeIn"}
                            label={"Paiement effectué en"}
                            handleChange={(e) => {
                              formik.setFieldValue(
                                `typeData.paymentMadeIn`,
                                e.target.value
                              );
                            }}
                            options={state.paymentOption}
                            className="transection-option"
                            value={
                              formik.values?.["typeData"]?.["paymentMadeIn"]
                            }
                            error={Boolean(
                              formik.errors?.["typeData"]?.["paymentMadeIn"]
                            )}
                            errorMessage={
                              formik.errors?.["typeData"]?.["paymentMadeIn"]
                            }
                          />
                        </>
                      )
                    ) : (
                      <></>
                    )}
                  </div>
                )}
                {formik.values?.["cashTransaction"] && (
                <Box className="p-5 pt-0" component="form" noValidate autoComplete="off">
                  <label className="mb-3">Donnez des détails sur l'opération</label>
                <TextareaAutosize
                    className="mb-4"
                    label="Donnez des détails sur l'opération"
                    aria-label="minimum height"
                    minRows={3}
                    onChange={formik.handleChange}
                    value={
                      formik.values?.["justification"]
                    }
                    error={Boolean(
                      formik.errors?.["justification"]
                    )}
                    errorMessage={
                      formik.errors?.["justification"]
                    }
                    name={"justification"}
                    placeholder="Ecrivez ici"
                    style={{ width: "100%",padding:"10px"  }}
                />
                </Box>
                 )}
                {formik.values?.["cashTransaction"] && (
                <Box className="p-5 pt-0" component="form" noValidate autoComplete="off">
                  <label className="mb-3">Téléverser un justificatif (Reçu banque,bordereau ....)</label>
                <input
                    accept=".pdf,.png,.jpg,.jpeg"
                    onChange={handleFileInputChange}
                    type={"file"}
                    fullWidth
                    className="mb-4"
                    name="proof"
                    label="Téléverser un justificatif"
                    style={{ width: "100%",padding:"10px", background:"white"  }}
                />
                </Box>
                 )}
              </div>
              
            </div>
            {Boolean(formik.errors["cashTransaction"]) && (
              <p className="errorText">{formik.errors["cashTransaction"]}</p>
            )}
          </div>
        </WelcomeLayout>
      </Grid>
    </div>
  );
};
export default Treasury;
